module.exports = __webpack_public_path__ + "media/components/country-flag/static/ng-ed44a94282cce8dc9864e9fa6cdf613a.svg";